<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import { Input } from "$lib/components/ui/input";
  import { X } from "@lucide/svelte";
  import { t } from "$lib/i18n";
  import { type CatalogIds, CATALOG_NAMES } from "@briefmarken_katalog/types";

  let {
    catalogIds = $bindable<CatalogIds>({}),
    isReadonly = false,
    containerClass = "grid grid-cols-4 items-center gap-4",
  }: { catalogIds: CatalogIds; isReadonly?: boolean; containerClass?: string } = $props();

  let isOpen = $state(false);

  const count = $derived(
    CATALOG_NAMES.filter((name) => catalogIds[name] !== undefined && catalogIds[name] !== "").length
  );

  function clear(name: (typeof CATALOG_NAMES)[number]) {
    const updated = { ...catalogIds };
    delete updated[name];
    catalogIds = updated;
  }
</script>

{#if isReadonly}
  {#if count > 0}
    <div class="grid grid-cols-4 items-start gap-4">
      <span class="text-right text-sm font-medium pt-1">{$t('catalogIds.button')}:</span>
      <div class="col-span-3 flex flex-col gap-1">
        {#each CATALOG_NAMES as name}
          {#if catalogIds[name]}
            <span class="text-sm"><span class="font-medium">{name}:</span> {catalogIds[name]}</span>
          {/if}
        {/each}
      </div>
    </div>
  {/if}
{:else}
  <div class={containerClass}>
    <div class="col-span-4 relative">
      <Button variant="outline" type="button" onclick={() => isOpen = !isOpen}>
        {$t('catalogIds.button')}{count > 0 ? ` (${count})` : ''}
      </Button>
      {#if isOpen}
        <div
          class="fixed inset-0 z-10"
          role="presentation"
          onclick={() => isOpen = false}
        ></div>
        <div class="absolute left-0 bottom-full z-20 mb-1 w-80 rounded-md border bg-background shadow-md p-3 flex flex-col gap-2">
          {#each CATALOG_NAMES as name}
            <div class="flex items-center gap-2 text-sm">
              <span class="w-28 shrink-0 font-medium">{name}</span>
              <Input
                class="flex-1 h-7 text-sm"
                value={catalogIds[name] ?? ""}
                oninput={(e) => {
                  const val = (e.target as HTMLInputElement).value;
                  catalogIds = val ? { ...catalogIds, [name]: val } : (() => { const u = { ...catalogIds }; delete u[name]; return u; })();
                }}
              />
              <button
                type="button"
                class="shrink-0 text-muted-foreground hover:text-destructive"
                aria-label={$t('catalogIds.clear')}
                onclick={() => clear(name)}
              >
                <X size={14} />
              </button>
            </div>
          {/each}
        </div>
      {/if}
    </div>
  </div>
{/if}
